module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07524_banner_800x600.14ea85f2.png";